
import css from 'styled-jsx/css';

export default css`.webinar-series {
  &__wrapper {
    display: grid;
    justify-content: center;
    grid-template-columns: [left-gutter] 1fr [content] 12fr [right-gutter] 1fr;
    padding: 2rem 0 3.75rem;

    @include media-query(tablet) {
      padding: 4.3125rem 0 8rem;
    }
  }

  &__inner {
    grid-column: content;
    max-width: 1290px;
    margin: 0 auto;
    width: 100%;
  }

  &__sorter-container {
    margin-bottom: 3.75rem;

    @include media-query(tablet) {
      margin-bottom: 7.625rem;
    }
  }

  &__webinars {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-column-gap: 20px;
    grid-row-gap: 20px;
    justify-content: space-between;
  }
}
`